module.exports = __webpack_public_path__ + "img/technology-10.3722e6d7.png";